import React, { FC } from 'react'

import { IconShareProps } from './IconShare.types'
import * as Styled from './styles/IconShare.style'

import { nonThemeableRules } from '../../ruleSet'

const IconShare: FC<IconShareProps> = ({
  size = nonThemeableRules.defaultSize as number as IconShareProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconShareProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M138.12 43.76a21.9 21.9 0 1 0-21-15.83L39.35 66.84a21.88 21.88 0 1 0-.44 26.88l69.46 37.66a21.93 21.93 0 1 0 3.82-7L42.71 86.69A21.8 21.8 0 0 0 42.92 74l77.77-38.92a21.86 21.86 0 0 0 17.43 8.68zm-8.94 80.48a13.88 13.88 0 1 1-13.88 13.88 13.9 13.9 0 0 1 13.88-13.88zM21.88 93.88A13.88 13.88 0 1 1 35.76 80a13.9 13.9 0 0 1-13.88 13.88zM138.12 8a13.88 13.88 0 1 1-13.88 13.88A13.9 13.9 0 0 1 138.12 8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconShare
